import { Button, Col, Row } from "antd";
import TextInput from "../inputs/TextInput";
import AddElementLayout from "../layouts/AddElementLayout";
import * as Yup from "yup";
import { postData } from "../../helpers/api";

const AddingNote = (props) => {
    const { orderId, isModalOpen, handleCancel, handleAfterAddingNote } = props

    const addNote = async (values, submitProps) => {
        try {
            await postData('notes/add',{
                note: values.note,
                orderId: orderId
            })
            handleAfterAddingNote()
        } catch (error) {

        }
    }
    return (
        <AddElementLayout
            title="Ajout de note"
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            initialValue={{
                note: ""
            }}
            validationSchema={Yup.object({
                note: Yup.string().required('required'),
            })}
            handleSubmitForm={(values, submitProps) => {
                addNote(values, submitProps)
            }}
        >
            <Row gutter={[8, 8]}>
                <Col lg={24}>
                    <TextInput
                        name="note"
                        placeholder="Note"
                        size="large"
                    />
                </Col>
                <Col lg={24}>
                    <Button size='large' type="primary" htmlType="submit">
                        Ajouter la note
                    </Button>
                </Col>
            </Row>
        </AddElementLayout>
    );
}

export default AddingNote;